import axios from "axios";

export default {
    namespaced: true,
    state: {
        rankingList: [],
    },
    getters: {
        rankingList: state => state.rankingList,
    },
    mutations: {
        get(state, data) {
            state.rankingList = data;
        },
    },
    actions: {
        async get({ commit }) {
            const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/contributor_ranking');
            commit('get', response.data)
            return response.data
        },
    },
}